import 'babel-polyfill';
import 'raf/polyfill';
import './assets/css/build.css';
import './browser';